import React from 'react';

import { Filter } from '@gogame/filters';

import {
  FILTER_PERIOD,
  FILTER_AFFILIATES,
  FILTER_APPLICATIONS,
  FILTER_NETWORKS,
  FILTERS_DEPENDENCIES,
  FILTER_CLUSTERS,
  FILTER_PLATFORMS,
  FILTER_TYPE,
  FILTER_SUB_TYPE,
  FILTER_CHANNELS,
  FILTER_MINE_ONLY,
} from 'scenes/Annotations/constants';
import {
  loadNetworks,
  loadApplications,
  loadTypes,
  loadSubTypesFilter,
  loadChannels,
  loadOnlyMineFilter,
  loadClusters,
  loadPlatforms,
  loadAffiliates,
} from 'scenes/Annotations/sources/filters';

export const Period = (props) => (
  <Filter.DateRangePicker
    title={'Period'}
    placeholder={'All'}
    name={FILTER_PERIOD}
    {...props}
  />
);

export const Affiliates = (props) => (
  <Filter.MultiSelect
    title={'Affiliates'}
    placeholder={'All'}
    name={FILTER_AFFILIATES}
    source={loadAffiliates}
    depends={FILTERS_DEPENDENCIES[FILTER_AFFILIATES]}
    {...props}
  />
);

export const Applications = (props) => (
  <Filter.MultiSelect
    title={'Applications'}
    placeholder={'All'}
    name={FILTER_APPLICATIONS}
    source={loadApplications}
    depends={FILTERS_DEPENDENCIES[FILTER_APPLICATIONS]}
    {...props}
  />
);

export const Networks = (props) => (
  <Filter.MultiSelect
    title={'Networks'}
    placeholder={'All'}
    name={FILTER_NETWORKS}
    source={loadNetworks}
    withAll={false}
    depends={FILTERS_DEPENDENCIES[FILTER_NETWORKS]}
    {...props}
  />
);

export const Clusters = (props) => (
  <Filter.MultiSelect
    title={'Clusters'}
    placeholder={'All'}
    name={FILTER_CLUSTERS}
    source={loadClusters}
    withAll={false}
    depends={FILTERS_DEPENDENCIES[FILTER_CLUSTERS]}
    {...props}
  />
);

export const Platforms = (props) => (
  <Filter.MultiSelect
    title={'Platforms'}
    placeholder={'All'}
    name={FILTER_PLATFORMS}
    source={loadPlatforms}
    withAll={false}
    depends={FILTERS_DEPENDENCIES[FILTER_PLATFORMS]}
    {...props}
  />
);

export const Type = (props) => (
  <Filter.Select
    title={'Type'}
    placeholder={'All'}
    name={FILTER_TYPE}
    source={loadTypes}
    {...props}
  />
);

export const SubTypes = (props) => {
  //@todo hard code. Please check m.buhlov.
  // const { valuesCollection, hierarchyStateCollection } =
  //   useContext(FiltersContext);
  // const disabled = !getIn(
  //   hierarchyStateCollection,
  //   `[0].${FILTER_SUB_TYPE}.data.length`
  // );

  return (
    <Filter.MultiSelect
      title={'Sub types'}
      placeholder={'All'}
      name={FILTER_SUB_TYPE}
      source={loadSubTypesFilter}
      // fieldActive={(fieldIndex) =>
      //   subTypesParamsSchema.isValidSync(valuesCollection[fieldIndex])
      // }
      // disabled={disabled}
      depends={FILTERS_DEPENDENCIES[FILTER_SUB_TYPE]}
      lazy={false}
      {...props}
    />
  );
};

export const OnlyMine = (props) => (
  <Filter.Select
    title={'Show'}
    placeholder={'All'}
    name={FILTER_MINE_ONLY}
    param={FILTER_MINE_ONLY}
    source={loadOnlyMineFilter}
    {...props}
  />
);

export const Channels = (props) => (
  <Filter.MultiSelect
    title={'Channels'}
    placeholder={'All'}
    name={FILTER_CHANNELS}
    source={loadChannels}
    {...props}
  />
);
